import { APP_BASE_URL_FROM_CONFIG, IMG_BASE_URL_FROM_CONFIG } from "../../config";

export const APP_BASE_URL = APP_BASE_URL_FROM_CONFIG;
export const IMG_BASE_URL = IMG_BASE_URL_FROM_CONFIG;

export default APP_BASE_URL;
